module.exports = __webpack_public_path__ + "static/media/pr-request-card-icon.f8bf935c.svg";